import { graphql } from '@client/graphql/types';
import { useMutation } from '@apollo/client';

const MUTATION = graphql(`
  mutation OnlineOrderOwnerToggleTag($id: ID!, $tag: String!) {
    onlineOrderOwnerToggleTag(id: $id, tag: $tag)
  }
`);

export default function useToggleOnlineOrderTag() {
  return useMutation(MUTATION, {
    refetchQueries: ['OnlineOrderDetail', 'OnlineOrderDashboard', 'OnlineOrderHistory'],
  });
}
